<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="info-content-container">
        <img
          class="slack-img"
          src="@shared/assets/img/general/slack.png"
          alt="slack"
        >
        <div class="info-header">
          Slack
        </div>
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggle(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <p>
        Review and action service requests, smartops recommendations,
        and more right from your slack
      </p>
      <div class="info-img-container">
        <img
          src="@shared/assets/img/general/slack-1-example.png"
          alt="1-example"
        >
        <img
          src="@shared/assets/img/general/slack-2-example.png"
          alt="2-example"
        >
      </div>
      <div class="info-img-header">
        Features
      </div>
      <div>
        <p class="review-info">
          Receive notifications in Slack for new service requests from members.
        </p>
        <p class="review-info">
          Receive notifications for new leads such as poor cooling performance and
          water detection to be seamlessly delivered to your Slack workspace.
        </p>
        <p class="review-info">
          Receive real-time alerts on Slack for high/low temperatures, low air
          filter life, and freeze warnings. Stay informed instantly.
        </p>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="info-form-button"
        @click="navToOauth"
      >
        Connect
      </button>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'SlackConnectPopup',
  mixins: [partnerSettingsMixin],
  props: {
    toggle: Function,
    serviceInfo: Object,
  },
  methods: {
    navToOauth() {
      const {
        token,
        access_token: accessToken,
      } = JSON.parse(localStorage.currentUser);
      const mt = accessToken || token;
      window.location = `${process.env.OAUTH_URL}/slack/link?mt=${mt}`;
    },
  },
};
</script>

<style lang="scss" scoped>

.info-content-container {
  align-items: flex-start;
  display: inline-flex;
  gap: 8px;
  width: 100%;
  .info-header {
    margin-top: 5px;
    color: $BLACK;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
}

.info-form-button {
  padding: 12px;
  height: 48px;
  border-radius: 6px;
  background-color: $NBLUE100;
  font-weight: 600;
  color: $WHITE;
  width: 255px;
}

.info-img-container {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 16px;
  width: 100%;
  img {
    flex: 1;
    height: 198px;
    object-fit: cover;
  }
}

.info-img-header {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $BLACK;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.review-info:before {
  content: "• ";
}
</style>
